<template>
	<div class="component-root">
		<div class="content_retix enedis-consent-result-view">
				<div class="container-retix">
					<div class="bloc_content consent-content">
						<h2 v-if="status == 'success'" :class="status">Autorisation Reçue.</h2>
						<h2 v-if="status == 'error'" :class="status">Consentement Enedis : problème rencontré</h2>
						
						<p v-if="customMsg" v-html="customMsg"></p>
						
						<div v-if="errorMsgList.length &gt; 0" class="error-list">
							
							<div class="error-list-title">Nous avons rencontré les erreurs suivantes :</div>
							
							<div class="error-msg" v-for="errorMsg in errorMsgList" :key="errorMsg.index" >
								{{errorMsg}}
							</div><!-- class="error-msg" -->
							
							<div class="error-list-footer">Nous sommes désolé de la gêne occasionée.</div>
							
						</div><!-- class="error-list" -->
						
						<div v-if="consent && consent.prmList && consent.prmList.length &gt; 0" class="prm-list">
							<div class="prm-list-title">Nous avons reçu l'autorisation pour les PRM suivants :</div>
														
							<div class="prm" v-for="prm in consent.prmList" :key="prm.index" >
								{{prm}}
							</div><!-- class="prm" -->
						</div><!-- class="prm-list" -->
						
						<div v-if="consent && consent.authorizationDatetime" class="">
							Cette autorisation a été accordée le {{formatDate(consent.authorizationDatetime)}}, pour une durée de {{consent.durationMonth}} mois.						
						</div>
					</div><!-- class="bloc_content" -->
				</div><!-- class="container-retix" -->
			</div><!-- class="content_retix enedis-consent-result-view"-->	
	</div>
</template>
<style scoped>

.content_retix {
	display:flex;
	flex-direction: column;	
}

.consent-content{
	display:flex;
	flex-direction: column;	
	gap:1rem;
}

h2 {
	font-size:1.5rem;
	margin-bottom: 1.5rem;
	padding:1rem;	
}

h2.success {
	background:var(--success);
	color:white;
}
h2.error {
	background:var(--danger);
	color:white;
}
.error-list {
	display:flex;
	flex-direction: column;	
	gap:1rem;
	
	
	
	.error-msg {
		padding:.5rem;
		background:var(--warning);
	}
}


.prm-list {
	display:flex;
	flex-direction: column;	
	gap:1rem;
	
	
	
	.prm {
		padding:.5rem;
		background:#b5d131;
	}
}

</style>
<script>
import {enedisConsentService} from '../services/enedisConsent';
import utils  from '../utils/util.ts'
import Vue from 'vue';

export default {

	props:	{
	},//props:	{
	
	data(){
		return {
			status:null,
			code:null,
			consent:null,
			customMsg:null,
			errorMsgList:[]
		};
	},//data(){
	
	mounted() {		
		let routeParams = this.$route.params
		let routeQuery = this.$route.query
		
		let hasStatus = routeQuery.hasOwnProperty("status")
		if(hasStatus){
			this.status = routeQuery.status
		}else{
			this.status = "error"
		}
		
		let hasErrorMsg = routeQuery.hasOwnProperty("error_msg[]")
		if(hasErrorMsg){
			let errorMsgParam = routeQuery['error_msg[]']
			let isString = typeof errorMsgParam === 'string' || errorMsgParam instanceof String;
			if(isString)
				this.errorMsgList.push(errorMsgParam)
			else
				this.errorMsgList = errorMsgParam
				
			console.log(this.errorMsgList )
		}
		
		let hasCode = routeParams.hasOwnProperty("code")
		if(hasCode){
			this.code = routeParams.code
		}else{
			this.code = null ;
		}
		
		
		if(this.code){
			let getForResultPromise = enedisConsentService.result(this.code )
			let successHandler = this.getForResultSuccess.bind(this)
			let errorHandler = this.restError.bind(this)
			getForResultPromise.then(successHandler).catch(errorHandler)
		}
	},// mounted() {
	
	
	
	methods : {
		getForResultSuccess(response){
			//console.log("views/EnedisConsentResult.vue:getForResultSuccess()",response.data)
			this.consent = response.data
			this.customMsg = null
			if(this.consent.informationMessage != null ){
				this.customMsg = utils.textToHtml(this.consent.informationMessage)
			}
			
		},//getForStartSuccess
		
		restError(error){
			//console.log("views/EnedisConsentResult.vue:restError()",error)
			let errorMessage = error.response.data.exception.message
			if(errorMessage)
				Vue.toasted.error(errorMessage);
			else
				Vue.toasted.error(error);
		},//restError(){
			
		formatDate(dateString) {
            if (!dateString) return "-";
            const date = new Date(dateString);
            return date.toLocaleString();
        },// formatDate(dateString)
	}//methods : {
}
</script>
